import { useState, useEffect } from "react";
import { useMyProviderDataClient } from "../../../../context/ApiContext";

export interface YQMCalendarItem {
  year: string;
  q1Begin: string;
  q1End: string;
  q2Begin: string;
  q2End: string;
  q3Begin: string;
  q3End: string;
  q4Begin: string;
  q4End: string;
  q1CP1?: string | null;
  q1CP2?: string | null;
  q1CP3?: string | null;
  q2CP1?: string | null;
  q2CP2?: string | null;
  q2CP3?: string | null;
  q3CP1?: string | null;
  q3CP2?: string | null;
  q3CP3?: string | null;
  q4CP1?: string | null;
  q4CP2?: string | null;
  q4CP3?: string | null;
}

export interface TimelineData {
  quarterStart: string;
  quarterEnd: string;
  cp1?: string | null;
  cp2?: string | null;
  cp3?: string | null;
}

export const useYQMCalendar = () => {
  const client = useMyProviderDataClient();
  const [calendarData, setCalendarData] = useState<YQMCalendarItem[]>([]);
  const [years, setYears] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>();

  useEffect(() => {
    const loadCalendar = async () => {
      try {
        setLoading(true);
        const res = await client.get<YQMCalendarItem[]>("/EmployeeInformation/YQMCalendar");
        const data = res.data;

        setCalendarData(data);

        const today = new Date();
        const currentYear = today.getFullYear();
        const yearOptions = data
          .map((y) => parseInt(y.year))
          .filter((y) => y <= currentYear && y >= 2023)
          .sort((a, b) => b - a)
          .map(String);

        setYears(yearOptions);
      } catch (err) {
        console.error(err);
        setError("Failed to load YQM calendar");
      } finally {
        setLoading(false);
      }
    };

    loadCalendar();
  }, [client]);

  return { calendarData, years, loading, error };
};